export const radarData = {
    "name": "Technology Radar",
    "subcategories": [
      {
        "name": "Techniques",
        "description": "Techniques description",
        "color": "#4a90e2",
        "subcategories": [
          {
            "name": "Development & Delivery Practices",
            "description": "Development & Delivery Practices description",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Software Development Practices",
                "subcategories": [
                  {
                    "name": "Agile Methodologies",
                    "subcategories": [
                      { "name": "Scrum", "approvalStage": "ADOPT" },
                      { "name": "Kanban", "approvalStage": "TRIAL" },
                      { "name": "Lean Software Development", "approvalStage": "ASSESS" },
                      { "name": "Extreme Programming (XP)", "approvalStage": "HOLD" },
                      { "name": "Scaled Agile Framework (SAFe)", "approvalStage": "HOLD" },
                      { "name": "Large-Scale Scrum (LeSS)", "approvalStage": "HOLD" },
                      { "name": "Disciplined Agile Delivery (DAD)", "approvalStage": "HOLD" },
                      { "name": "Agile Unified Process (AUP)", "approvalStage": "HOLD" },
                      { "name": "Scrum of Scrums", "approvalStage": "HOLD" }
                    ]
                  },
                  { "name": "System Design" },
                  { "name": "Code Review Practices" },
                  { "name": "Documentation Practices" }
                ]
              },
              {
                "name": "DevOps Practices",
                "subcategories": [
                  { "name": "Continuous Integration" },
                  { "name": "Continuous Delivery" },
                  { "name": "Infrastructure as Code" },
                  { "name": "Configuration Management" }
                ]
              },
              {
                "name": "DevSecOps Practices",
                "subcategories": [
                  { "name": "Security Testing" },
                  { "name": "Vulnerability Management" },
                  { "name": "Security Monitoring" }
                ]
              },
              {
                "name": "User Experience (UX) Practices",
                "subcategories": [
                  { "name": "User Research" },
                  { "name": "Usability Testing" },
                  { "name": "Design Systems" }
                ]
              }
            ]
          },
          {
            "name": "Collaboration & Project Management",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Collaboration and Workflow",
                "subcategories": [
                  { "name": "Remote Work Practices" },
                  { "name": "Communication Protocols" },
                  { "name": "Knowledge Sharing" }
                ]
              },
              {
                "name": "Project Management and Governance",
                "subcategories": [
                  { "name": "Project Planning" },
                  { "name": "Risk Management" },
                  { "name": "Resource Allocation" }
                ]
              },
              {
                "name": "Teams Organization and Collaboration",
                "subcategories": [
                  { "name": "Stream-Aligned Teams" },
                  { "name": "Enabling Teams" },
                  { "name": "Platform Teams" }
                ]
              },
              {
                "name": "Productivity Metrics",
                "subcategories": [
                  { "name": "Code Coverage" },
                  { "name": "Deployment Frequency" },
                  { "name": "Lead Time" }
                ]
              }
            ]
          },
          {
            "name": "Quality & Testing",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Quality Assurance and Testing Techniques",
                "subcategories": [
                  { "name": "Test Automation" },
                  { "name": "Performance Testing" },
                  { "name": "Security Testing" }
                ]
              },
              {
                "name": "Compliance and Standards",
                "subcategories": [
                  { "name": "Data Protection Regulations" },
                  { "name": "Security Standards" },
                  { "name": "Quality Standards" }
                ]
              }
            ]
          },
          {
            "name": "Performance & Scalability",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Performance and Scalability Practices",
                "subcategories": [
                  { "name": "Load Balancing" },
                  { "name": "Caching Strategies" },
                  { "name": "Database Optimization" }
                ]
              },
              {
                "name": "Legacy Systems Modernization",
                "subcategories": [
                  { "name": "Refactoring" },
                  { "name": "Migration Strategies" },
                  { "name": "System Integration" }
                ]
              }
            ]
          },
          {
            "name": "Process Improvement & Optimization",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Process Improvement Techniques",
                "subcategories": [
                  { "name": "Lean Practices" },
                  { "name": "Value Stream Mapping" },
                  { "name": "Continuous Improvement" }
                ]
              },
              {
                "name": "Productivity Metrics",
                "subcategories": [
                  { "name": "Cycle Time" },
                  { "name": "Sprint Velocity" },
                  { "name": "Team Performance" }
                ]
              }
            ]
          },
          {
            "name": "AI and Emerging Technologies",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "AI and Machine Learning Practices",
                "subcategories": [
                  { "name": "Model Training" },
                  { "name": "Data Pipeline Management" },
                  { "name": "MLOps" },
                  { "name": "Prompt Engineering" }
                ]
              }
            ]
          }
        ]
      },
      {
        "name": "Tools",
        "color": "#4a90e2",
        "subcategories": [
          {
            "name": "Development & Coding Tools",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Version Control Systems",
                "subcategories": [
                  { "name": "GitHub" },
                  { "name": "GitLab" },
                  { "name": "Bitbucket" }
                ]
              },
              {
                "name": "Integrated Development Environments (IDEs) and Code Editors",
                "subcategories": [
                  { "name": "Visual Studio Code" },
                  { "name": "Visual Studio" },
                  { "name": "IntelliJ IDEA" },
                  { "name": "Vim" },
                  { "name": "Android Studio" },
                  { "name": "PyCharm" },
                  { "name": "Jupyter Notebook/JupyterLab" },
                  { "name": "Eclipse" },
                  { "name": "Xcode" },
                  { "name": "Rider" },
                  { "name": "NeoVim" },
                  { "name": "WebStorm" },
                  { "name": "PhpStorm" }
                ]
              },
              {
                "name": "Build Tools",
                "subcategories": [
                  { "name": "Make" },
                  { "name": "Vite" },
                  { "name": "Webpack" },
                  { "name": "Babel" },
                  { "name": "MSBuild" },
                  { "name": "Ant" },
                  { "name": "Ninja" },
                  { "name": "ESbuild" }
                ]
              },
              {
                "name": "Code Quality and Static Analysis Tools",
                "subcategories": [
                  { "name": "SonarQube" },
                  { "name": "CodeClimate" },
                  { "name": "Checkstyle" },
                  { "name": "PMD" }
                ]
              },
              {
                "name": "Testing and Quality Assurance Tools",
                "subcategories": [
                  { "name": "Jest" },
                  { "name": "Selenium" },
                  { "name": "JUnit" },
                  { "name": "Cypress" },
                  { "name": "Postman" }
                ]
              },
              {
                "name": "Automated Linters",
                "subcategories": [
                  { "name": "ESLint" },
                  { "name": "StyleLint" },
                  { "name": "Pylint" }
                ]
              },
              {
                "name": "Code Formatters Tools",
                "subcategories": [
                  { "name": "Prettier" },
                  { "name": "Black" },
                  { "name": "gofmt" }
                ]
              }
            ]
          },
          {
            "name": "CI/CD & DevOps Tools",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Continuous Integration/Continuous Deployment (CI/CD) Tools",
                "subcategories": [
                  { "name": "Jenkins" },
                  { "name": "GitLab CI" },
                  { "name": "GitHub Actions" },
                  { "name": "CircleCI" },
                  { "name": "Travis CI" }
                ]
              },
              {
                "name": "Deployment and Release Automation Tools",
                "subcategories": [
                  { "name": "Spinnaker" },
                  { "name": "ArgoCD" },
                  { "name": "Octopus Deploy" }
                ]
              },
              {
                "name": "Containerization and Orchestration Tools",
                "subcategories": [
                  { "name": "Docker" },
                  { "name": "Kubernetes" },
                  { "name": "Helm" },
                  { "name": "Podman" }
                ]
              },
              {
                "name": "Infrastructure as Code and Configuration Management Tools",
                "subcategories": [
                  { "name": "Terraform" },
                  { "name": "Ansible" },
                  { "name": "Puppet" },
                  { "name": "Chef" }
                ]
              }
            ]
          },
          {
            "name": "Monitoring & Security Tools",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Monitoring, Logging, and Observability Tools",
                "subcategories": [
                  { "name": "Prometheus" },
                  { "name": "Grafana" },
                  { "name": "ELK Stack" },
                  { "name": "New Relic" },
                  { "name": "Datadog" }
                ]
              },
              {
                "name": "Security Tools",
                "subcategories": [
                  { "name": "OWASP ZAP" },
                  { "name": "Snyk" },
                  { "name": "SonarQube Security" },
                  { "name": "Fortify" }
                ]
              },
              {
                "name": "Secrets Management Systems",
                "subcategories": [
                  { "name": "HashiCorp Vault" },
                  { "name": "AWS Secrets Manager" },
                  { "name": "Azure Key Vault" }
                ]
              },
              {
                "name": "AI Scanning and Developer Tools",
                "subcategories": [
                  { "name": "GitHub Copilot" },
                  { "name": "Amazon CodeWhisperer" },
                  { "name": "Snyk Code AI" }
                ]
              }
            ]
          },
          {
            "name": "Database & Data Management Tools",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Database Engines and Data Storage Technologies",
                "subcategories": [
                  { "name": "PostgreSQL" },
                  { "name": "MongoDB" },
                  { "name": "MySQL" },
                  { "name": "Redis" },
                  { "name": "Elasticsearch" }
                ]
              },
              {
                "name": "Database Migration and Indexing Tools",
                "subcategories": [
                  { "name": "Flyway" },
                  { "name": "Liquibase" },
                  { "name": "Elasticsearch" }
                ]
              }
            ]
          },
          {
            "name": "Collaboration & Documentation Tools",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Visual Collaboration, Communication, and Diagramming Tools",
                "subcategories": [
                  { "name": "Miro" },
                  { "name": "Figma" },
                  { "name": "Draw.io" },
                  { "name": "Lucidchart" }
                ]
              },
              {
                "name": "Project Management and Issue Tracking Tools",
                "subcategories": [
                  { "name": "Jira" },
                  { "name": "Trello" },
                  { "name": "Asana" },
                  { "name": "Monday.com" }
                ]
              },
              {
                "name": "API Management and Documentation Tools",
                "subcategories": [
                  { "name": "Swagger/OpenAPI" },
                  { "name": "Postman" },
                  { "name": "Kong" }
                ]
              },
              {
                "name": "Documentation and Knowledge Management Tools",
                "subcategories": [
                  { "name": "Confluence" },
                  { "name": "Notion" },
                  { "name": "GitBook" },
                  { "name": "Docusaurus" }
                ]
              }
            ]
          },
          {
            "name": "Dependency & Package Management Tools",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Package Managers and Dependency Management Tools",
                "subcategories": [
                  { "name": "npm" },
                  { "name": "pip" },
                  { "name": "Maven" },
                  { "name": "Gradle" },
                  { "name": "NuGet" }
                ]
              },
              {
                "name": "Artifact Repositories and Package Storage",
                "subcategories": [
                  { "name": "Nexus" },
                  { "name": "Artifactory" },
                  { "name": "GitHub Packages" }
                ]
              }
            ]
          }
        ]
      },
      {
        "name": "Platforms",
        "color": "#4a90e2",
        "subcategories": [
          {
            "name": "Development & Integration Platforms",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Low-Code and No-Code Platforms",
                "subcategories": [
                  { "name": "OutSystems" },
                  { "name": "Mendix" },
                  { "name": "Power Apps" }
                ]
              },
              {
                "name": "Data Integration and ETL Platforms",
                "subcategories": [
                  { "name": "Apache NiFi" },
                  { "name": "Talend" },
                  { "name": "Informatica" }
                ]
              },
              {
                "name": "Workflow and Automation Platforms",
                "subcategories": [
                  { "name": "Zapier" },
                  { "name": "Microsoft Power Automate" },
                  { "name": "Apache Airflow" }
                ]
              },
              {
                "name": "Mobile Backend as a Service (MBaaS) Platforms",
                "subcategories": [
                  { "name": "Firebase" },
                  { "name": "AWS Amplify" },
                  { "name": "Back4App" }
                ]
              }
            ]
          },
          {
            "name": "Data & Analytics Platforms",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Big Data and Analytics Platforms",
                "subcategories": [
                  { "name": "Hadoop" },
                  { "name": "Spark" },
                  { "name": "Databricks" }
                ]
              },
              {
                "name": "Data Storage and Management Platforms",
                "subcategories": [
                  { "name": "MongoDB Atlas" },
                  { "name": "Amazon RDS" },
                  { "name": "Snowflake" }
                ]
              },
              {
                "name": "Content Delivery Networks (CDN)",
                "subcategories": [
                  { "name": "Cloudflare" },
                  { "name": "Akamai" },
                  { "name": "Fastly" }
                ]
              }
            ]
          },
          {
            "name": "Infrastructure & Hosting Platforms",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Cloud Platforms",
                "subcategories": [
                  { "name": "AWS" },
                  { "name": "Azure" },
                  { "name": "Google Cloud Platform" }
                ]
              },
              {
                "name": "Serverless Platforms",
                "subcategories": [
                  { "name": "AWS Lambda" },
                  { "name": "Azure Functions" },
                  { "name": "Google Cloud Functions" }
                ]
              },
              {
                "name": "Platform as a Service (PaaS)",
                "subcategories": [
                  { "name": "Heroku" },
                  { "name": "Google App Engine" },
                  { "name": "Azure App Service" }
                ]
              },
              {
                "name": "Virtualization Platforms",
                "subcategories": [
                  { "name": "VMware" },
                  { "name": "VirtualBox" },
                  { "name": "Hyper-V" }
                ]
              },
              {
                "name": "Container Registry Platforms",
                "subcategories": [
                  { "name": "Docker Hub" },
                  { "name": "Amazon ECR" },
                  { "name": "Google Container Registry" }
                ]
              }
            ]
          },
          {
            "name": "Application & Middleware Platforms",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Middleware Platforms",
                "subcategories": [
                  { "name": "Apache Tomcat" },
                  { "name": "JBoss" },
                  { "name": "WebSphere" }
                ]
              },
              {
                "name": "Enterprise Service Bus (ESB)",
                "subcategories": [
                  { "name": "MuleSoft" },
                  { "name": "Apache Camel" },
                  { "name": "WSO2" }
                ]
              },
              {
                "name": "Mobile App Distribution",
                "subcategories": [
                  { "name": "App Store" },
                  { "name": "Google Play" },
                  { "name": "TestFlight" }
                ]
              }
            ]
          },
          {
            "name": "Monitoring & Security Platforms",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Application Performance Monitoring (APM) Platforms",
                "subcategories": [
                  { "name": "New Relic" },
                  { "name": "Datadog" },
                  { "name": "Dynatrace" }
                ]
              },
              {
                "name": "Monitoring and Logging Platforms",
                "subcategories": [
                  { "name": "ELK Stack" },
                  { "name": "Splunk" },
                  { "name": "Grafana" }
                ]
              },
              {
                "name": "Identity and Access Management Platforms",
                "subcategories": [
                  { "name": "Okta" },
                  { "name": "Auth0" },
                  { "name": "Keycloak" }
                ]
              },
              {
                "name": "Alerting Platforms",
                "subcategories": [
                  { "name": "PagerDuty" },
                  { "name": "OpsGenie" },
                  { "name": "VictorOps" }
                ]
              }
            ]
          },
          {
            "name": "Emerging Technologies",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Blockchain Platforms",
                "subcategories": [
                  { "name": "Ethereum" },
                  { "name": "Hyperledger" },
                  { "name": "Solana" }
                ]
              },
              {
                "name": "Edge Computing Platforms",
                "subcategories": [
                  { "name": "Azure IoT Edge" },
                  { "name": "AWS IoT Greengrass" },
                  { "name": "Google Cloud IoT Edge" }
                ]
              },
              {
                "name": "Internet of Things (IoT) Platforms",
                "subcategories": [
                  { "name": "AWS IoT" },
                  { "name": "Azure IoT Hub" },
                  { "name": "Google Cloud IoT Core" }
                ]
              },
              {
                "name": "Artificial Intelligence and Machine Learning Platforms",
                "subcategories": [
                  { "name": "TensorFlow" },
                  { "name": "PyTorch" },
                  { "name": "Azure ML" }
                ]
              }
            ]
          },
          {
            "name": "Communication & Messaging Platforms",
            "color": "#c23531",
            "subcategories": [
              {
                "name": "Message Brokers and Streaming Platforms",
                "subcategories": [
                  { "name": "Apache Kafka" },
                  { "name": "RabbitMQ" },
                  { "name": "Redis" }
                ]
              }
            ]
          }
        ]
      },
      {
        "name": "Languages & Frameworks",
        "color": "#fac858",
        "subcategories": [
          { 
            "name": "Programming, Scripting and Markup Languages",
            "color": "#c4876a",
            "subcategories": [
              { "name": "Virtual Offices" },
              { "name": "Remote Collaboration" }
            ]
          },
          { 
            "name": "Frameworks",
            "color": "#c4876a",
            "subcategories": [
              { "name": "Virtual Offices" },
              { "name": "Remote Collaboration" }
            ]
          },
          { 
            "name": "Third-Party Libraries",
            "color": "#c4876a",
            "subcategories": [
              { "name": "FrontEnd" },
              { "name": "BackEnd" },
              { "name": "Mobile Development" }
            ]
          },
        ]
      }
  ]
}; 
